import { styles as componentStyles } from './shared.scss';
import { styles as footerStyles } from './table-footer.scss';
import { styles as rowSelectionStyles } from './row-selection.scss';
import { styles as rowReorderingStyles } from './row-reordering.scss';
import { styles as rowEditingStyle } from './row-editing.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as textHelpersStyles } from '../../../assets/text-helpers.scss';
import { styles as styleHelpers } from '../../../assets/style-helpers.scss';
import { styles as flexboxHelpersStyles } from '../../../assets/flexbox-helpers.scss';
import { unsafeCSS } from 'lit';

export const styles = [
  unsafeCSS(`${flexboxHelpersStyles}`),
  unsafeCSS(`${styleHelpers}`),
  unsafeCSS(`${textHelpersStyles}`),
  unsafeCSS(`${commonStyles}`),
  unsafeCSS(`${componentStyles}`),
  // the order of decorator styles is important. It should follow the reverse order of the class decorators
  unsafeCSS(`${footerStyles}`),
  unsafeCSS(`${rowSelectionStyles}`),
  unsafeCSS(`${rowEditingStyle}`),
  unsafeCSS(`${rowReorderingStyles}`),
];
